import ScrollPage, {SectionItem} from "../../Components/ScrollPage/ScrollPage";
import Section from "../../Components/Section/Section";
import WankelStory from "../../Content/WenkleStory/WankleStory";

interface ScrollTo {
  index: number;
}

export const Sections: SectionItem[] = [
  { label: "Wankel",        id: "wankel" }
];


const OurStory: React.FC<ScrollTo> = ({ index }) => (
  <ScrollPage index={index} sections={Sections}>
    <Section section={Sections[0].id}>
      <WankelStory />
    </Section>
  </ScrollPage>
);

export default OurStory;